import React from "react";
import { NavLink } from "react-router-dom";

const NewsLetter = () => {
  return (
    <div className="relative w-full h-[500px] bg-cover bg-center flex items-center justify-center">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(/assets/newsletterImage.webp)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-[#4C426D] opacity-60" />

      {/* Content */}
      <div className="relative flax-col flax gap-3 text-center text-white px-2">
      <div className="text-4xl md:text-5xl md:max-w-[48rem] font-bold leading-tight md:leading-[3.5rem] mb-4">
      Let's Make Your Product Look Nice By Packaging.
        </div>
        <div className="text-lg md:text-base max-w-xl mx-auto mb-6">
          Sign up for our newsletter to get insights, tips, and the latest
          product updates about our thermocol solutions for your business.
        </div>
        <NavLink
          to="/products"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="px-8 py-5 max-w-[12rem] bg-primary-100 text-white font-semibold text-sm shadow-md relative"
        >
          Discover More
        </NavLink>
      </div>
    </div>
  );
};

export default NewsLetter;
